export const SET_FORM_DATA = "SET_FORM_DATA";
export const SET_RAW_FILE_DATA_SUCCESS = "SET_RAW_FILE_DATA_SUCCESS";
export const SET_RAW_FILE_DATA_FAILURE = "SET_RAW_FILE_DATA_FAILURE";
export const SET_VALIDATED_FILE_DATA_SUCCESS =
  "SET_VALIDATED_FILE_DATA_SUCCESS";
export const CLEAR_REDUX_STATE = "CLEAR_REDUX_STATE";
